import { render, staticRenderFns } from "./preMaterialDemage.vue?vue&type=template&id=227effee&scoped=true&"
import script from "./preMaterialDemage.vue?vue&type=script&lang=js&"
export * from "./preMaterialDemage.vue?vue&type=script&lang=js&"
import style0 from "./preMaterialDemage.vue?vue&type=style&index=0&id=227effee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227effee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
